<template>
  <Layout>
    <component
      :is="componentName"
      :two-fa-response="twoFaResponse"
      class="basic-wrapper form-wrapper"
      @continue-2fa="continue2fa"
    />
  </Layout>
</template>

<script>
import Layout from '@/layout/public'
import LoginForm from './LoginForm.vue'
import SecurityVerification from './SecurityVerification.vue'

export default {
  name: 'Login',
  page: {
    title: 'Вход',
  },
  components: {
    Layout,
    LoginForm,
    SecurityVerification,
  },
  data() {
    return {
      componentName: 'LoginForm',
      twoFaResponse: null,
    }
  },
  methods: {
    continue2fa(response) {
      this.twoFaResponse = response
      this.componentName = 'SecurityVerification'
    },
  },
}
</script>
